import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { IEnvironmentState } from "./persistedSlices/environment";
import createEnvironmentSlice from "./persistedSlices/environment";
import type { ISelectionState } from "./persistedSlices/selection";
import createSelectionSlice from "./persistedSlices/selection";
import createSnackbarSlice, {
  ISnackbarState,
} from "./persistedSlices/snackbar";

export type IState = ISelectionState & IEnvironmentState & ISnackbarState;

const usePersistedStore = create<IState>()(
  persist(
    (...a) => ({
      ...createSelectionSlice(...a),
      ...createEnvironmentSlice(...a),
      ...createSnackbarSlice(...a),
    }),
    {
      name: "persisted-state",
    },
  ),
);

export default usePersistedStore;
